import React, { useEffect } from 'react';
import { Footer } from './components/Footer';
import { MobileTopButton } from './components/MobileTopButton';
import { SiteHeader } from './components/SiteHeader';
import { StickyCTA } from './components/StickyCTA';
import { useCurrentRoute } from './lib/router';
import { HomePage } from './pages/HomePage';
import { MembershipPage } from './pages/MembershipPage';
import { RetreatSpacePage } from './pages/RetreatSpacePage';
import { StaysPage } from './pages/StaysPage';
const PAGE_TITLES: Record<string, string> = {
  '/': 'Pines Retreat | Sauna, Ice Baths & Retreat Stay Near Pardes Hanna',
  '/space': 'Retreat Space | Pines Retreat',
  '/stay': 'Stay Overnight Near Pardes Hanna | Pines Retreat',
  '/membership': 'Pines Membership | Pines Retreat'
};
export function App() {
  const route = useCurrentRoute();
  useEffect(() => {
    document.title = PAGE_TITLES[route] ?? PAGE_TITLES['/'];
  }, [route]);
  const page = {
    '/': <HomePage data-id="element-0" data-mp="23v2rsz5cwt3a" />,
    '/space': <RetreatSpacePage data-id="element-1" data-mp="3ijxpqrsp22kf" />,
    '/stay': <StaysPage data-id="element-2" data-mp="3ikqz80j1f669" />,
    '/membership': <MembershipPage data-id="element-3" data-mp="3ijpbowku4r7n" />
  }[route] ?? <HomePage data-id="element-4" data-mp="3mlj8gtrwtb2j" />;
  return <div className="min-h-screen bg-cream font-sans text-pine selection:bg-ember selection:text-cream" data-id="element-5" data-mp="3mkrefndynled">
      <SiteHeader data-id="element-6" data-mp="3rbzpsoyupgu6" />
      <main className="pb-20 md:pb-0" data-id="element-7" data-mp="3rcsxpt9jqcdw">{page}</main>
      <Footer data-id="element-8" data-mp="5otf64sd496" />
      <StickyCTA data-id="element-9" data-mp="6htjo98ovic" />
      <MobileTopButton data-id="element-10" data-mp="4wylxj0jajy" />
    </div>;
}